import { render, staticRenderFns } from "./skeleton-search.vue?vue&type=template&id=5ecb3aed&scoped=true&"
import script from "./skeleton-search.vue?vue&type=script&lang=js&"
export * from "./skeleton-search.vue?vue&type=script&lang=js&"
import style0 from "./skeleton-search.vue?vue&type=style&index=0&id=5ecb3aed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb3aed",
  null
  
)

export default component.exports